import type { TypographyProps, TypographyVariant } from './types'
import cn from 'classnames'
import React from 'react'
import styles from './Typography.module.css'

const VARIANT_TO_CLASS: Record<TypographyVariant, keyof typeof styles> = {
  'body-l-regular-loose': 'bodyLRegularLoose',
  'body-l-regular-snug': 'bodyLRegularSnug',
  'body-l-regular-tight': 'bodyLRegularTight',
  'body-l-regular-flat': 'bodyLRegularFlat',
  'body-l-bold-loose': 'bodyLBoldLoose',
  'body-l-bold-snug': 'bodyLBoldSnug',
  'body-l-bold-tight': 'bodyLBoldTight',
  'body-l-bold-flat': 'bodyLBoldFlat',
  'body-m-regular-loose': 'bodyMRegularLoose',
  'body-m-regular-snug': 'bodyMRegularSnug',
  'body-m-regular-tight': 'bodyMRegularTight',
  'body-m-regular-flat': 'bodyMRegularFlat',
  'body-m-bold-loose': 'bodyMBoldLoose',
  'body-m-bold-snug': 'bodyMBoldSnug',
  'body-m-bold-tight': 'bodyMBoldTight',
  'body-m-bold-flat': 'bodyMBoldFlat',
  'body-s-regular-loose': 'bodySRegularLoose',
  'body-s-regular-snug': 'bodySRegularSnug',
  'body-s-regular-tight': 'bodySRegularTight',
  'body-s-regular-flat': 'bodySRegularFlat',
  'body-s-bold-loose': 'bodySBoldLoose',
  'body-s-bold-snug': 'bodySBoldSnug',
  'body-s-bold-tight': 'bodySBoldTight',
  'body-s-bold-flat': 'bodySBoldFlat',
  'body-xs-regular-loose': 'bodyXsRegularLoose',
  'body-xs-regular-snug': 'bodyXsRegularSnug',
  'body-xs-regular-tight': 'bodyXsRegularTight',
  'body-xs-regular-flat': 'bodyXsRegularFlat',
  'body-xs-bold-loose': 'bodyXsBoldLoose',
  'body-xs-bold-snug': 'bodyXsBoldSnug',
  'body-xs-bold-tight': 'bodyXsBoldTight',
  'body-xs-bold-flat': 'bodyXsBoldFlat',
  'display-a-regular': 'displayARegular',
  'display-b-regular': 'displayBRegular',
  'display-c-regular': 'displayCRegular',
  'display-d-regular': 'displayDRegular',
  'display-e-regular': 'displayERegular',
  'display-f-regular': 'displayFRegular',
  'display-g-regular': 'displayGRegular',
  'display-h-regular': 'displayHRegular',
  'display-i-regular': 'displayIRegular',
  'display-j-regular': 'displayJRegular',
}

export default function Typography<C extends React.ElementType = 'span'>({
  className,
  children,
  as,
  variant: variantProp,
  ...rest
}: TypographyProps<C>) {
  const Component = as || 'span'
  const variant = variantProp || 'body-m-regular-snug'

  const variantClass = styles[VARIANT_TO_CLASS[variant]]

  return (
    <Component
      className={cn(styles.typography, variantClass, className)}
      {...rest}
    >
      {children}
    </Component>
  )
}
